<template>
<div class="information_container">
  <div class="header_container">
    <h3>{{ $t('accountInformation') }}</h3>
  </div>
  <div class='security_link'>
    <h4 class="subtitle">{{ $t('loginSecurity') }}</h4>
    <div class="detail_container">
      <div class="each_info"><span class="descriptions">{{ $t('email') }}</span><span>{{customerInformation.email}}</span><span class="btn_link">
          <!-- <el-tooltip class="item" effect="dark" content="Developers are working on it" placement="right-start"> -->
            <p v-if="customerInformation.verify_email">{{ $t('verified') }}</p>
            <p v-else @click="handleVerifyEmailClick">
              {{ $t('verify') }}
            </p>
          <!-- </el-tooltip> -->
        </span></div>
      <div class="each_info"><span class="descriptions">{{ $t('password') }}</span><span>**************</span><span class="btn_link" @click="dialogFormVisible = true">{{ $t('change') }}</span></div>
      <div class="each_info"><span class="descriptions">{{ $t('phone') }}</span><span>{{customerInformation.Phone ? customerInformation.Phone : 'None'}}</span><span class="btn_link">
          <el-tooltip class="item" effect="dark" content="Developers are working on it" placement="right-start">
            <p>
              {{ $t('edit') }}
            </p>
          </el-tooltip>
        </span></div>
    </div>
  </div>
  <div class='security_link'>
    <h4 class="subtitle">{{ $t('linkAccount') }}</h4>
    <div class="detail_container">
      <div class="each_info"><span class="descriptions"><img :src="WechatIcon" alt=""></span><span>{{ $t('wechat') }}</span><span class="btn_link">
          <el-tooltip class="item" effect="dark" content="Coming up soon" placement="right-start">
            <p>
              {{ $t('link') }}
            </p>
          </el-tooltip>
        </span></div>
      <!-- <div class="each_info"><span class="descriptions"><img :src="WeiboIcon" alt=""></span><span>Weibo</span><span class="btn_link">
          <el-tooltip class="item" effect="dark" content="Coming up soon" placement="right-start">
            <p>
              Link
            </p>
          </el-tooltip>
        </span></div> -->
      <div class="each_info"><span class="descriptions"><img :src="FacebookIcon" alt=""></span><span>Facebook</span><span class="btn_link">
          <el-tooltip class="item" effect="dark" content="Coming up soon" placement="right-start">
            <p>
              {{ $t('link') }}
            </p>
          </el-tooltip>
        </span></div>
    </div>
  </div>

  <el-dialog title="Change Password" :visible.sync="dialogFormVisible" :beforeClose="handleDialogBeforeClose" :width="windowWidth > 800 ? '30%' : '80%'" class="modal">
    <el-form :model="form" :rules="rules">
      <el-form-item prop="old_password">
        <el-input placeholder="Current Password" v-model="form.old_password" type='password'></el-input>
      </el-form-item>
      <el-form-item prop="new_password">
        <el-input placeholder="New Password" v-model="form.new_password" type='password'></el-input>
      </el-form-item>
      <el-form-item prop="newPasswordAgain">
        <el-input placeholder="Reenter New Password" v-model="form.newPasswordAgain" type='password'></el-input>
      </el-form-item>
      <p v-if='form.passwordNotMatch'>{{ $t('passwordMatch') }}</p>
      <p v-if="form.oldPasswordNotMatch">{{ $t('passwordWrong') }}</p>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="handlePasswordChangeSubmit($event, form)" class="confirmBtn">{{ $t('confirm') }}</el-button>
    </span>
  </el-dialog>

</div>
</template>

<script>
import WechatIcon from '../../assets/img/wechatnew1.png'
import WeiboIcon from '../../assets/img/weibo-icon.png'
import FacebookIcon from '../../assets/img/facebook_circle-512.png'
import {
  mapActions,
  mapState,
} from 'vuex'
export default {
  name: 'account-info',
  data() {
    return {
      stateOptions: this.$store.state.addresses.states,
      WechatIcon: WechatIcon,
      WeiboIcon: WeiboIcon,
      FacebookIcon: FacebookIcon,
      form: {
        old_password: '',
        new_password: '',
        newPasswordAgain: '',
        passwordNotMatch: false,
        oldPasswordNotMatch: false,
      },
      rules: {

      },
      dialogFormVisible: false,
      windowWidth: document.documentElement.clientWidth,

      email: '',
      phone: '',
    }
  },
  methods: {
    ...mapActions('auth', ['changePassword', 'fetchCustomerInformation']),
    ...mapActions('profile', ['verifyEmail']),
    handleVerifyEmailClick() {
      console.log('you clicked on verify email', this);
      return;
      this.verifyEmail()
      .then(res => {
        this.$alert('An Confirmation Email has been sent to you email address', 'Success', {
          confirmButtonText: 'OK',
          type: 'success',
          center: true
        }).then(() => {
          // this.dialogVisible = false;
        }).catch(() => {});
      })
      .catch(err => console.log('err verifying email address', address))
    },
    clearFormData() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    handleDialogBeforeClose() {
      this.clearFormData();
      this.dialogFormVisible = false;
    },
    handleResize(size) {
      this.windowWidth = document.documentElement.clientWidth
    },
    showPwChangedAlert() {
      this.$alert('You have successfully changed account password', 'Success', {
        confirmButtonText: 'OK',
        type: 'success',
        center: true
      }).then(() => {
        // this.dialogVisible = false;
      }).catch(() => {});
    },
    handlePasswordChangeSubmit(event, form) {
      event.preventDefault();
      this.form.passwordNotMatch = false;
      if (form.new_password !== form.newPasswordAgain) {
        this.form.passwordNotMatch = true;
        return
      }
      const data = {
        new_password: form.new_password,
        old_password: form.old_password,
      }
      this.changePassword(data)
        .then(res => {
          this.dialogFormVisible = false;
          this.clearFormData();
          this.showPwChangedAlert();
        })
        .catch(err => {
          this.form.oldPasswordNotMatch = true;
          return;
        })
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: mapState({
    customerInformation: state => state.auth.userDetails,
  })
}
</script>

<style lang="less" scope>
// @import "../../assets/css/profile.less";
.information_container {
  // border: 3px solid red;
  padding: 5% 5%;
  max-width: 600px;

  .confirmBtn {
    background-color: #ff6f37;
    border: 1px transparent solid;
  }

  .el-input__inner {
    background-color: #fce4bd;
    color: #000;
    border: none;
    border-radius: 5px;
  }

  input::-webkit-input-placeholder {
    color: #000000;
  }

  input::-ms-input-placeholder {
    color: #000000;
  }

  .security_link {
    margin: 5% 0 10% 0;

    .descriptions {
      color: grey;
      display: inline-block;
      width: 100px;

      // text-align: center;
      img {
        vertical-align: middle;
      }
    }

    span {
      img {
        width: 40px;
        border-radius: 50%;
      }
    }
  }

  .each_info {
    line-height: 50px;
  }

  .detail_container {
    .btn_link {
      float: right
    }

    img {
      width: 40px;
      border-radius: 50%;
    }

    .btn_link {
      text-decoration: underline;
      cursor: pointer;
    }

    .btn_link:hover {
      color: #f5a623
    }
  }

  .subtitle {
    margin: 5% 0;
  }

  // .fieldset {
  // padding: 33px 25px;

  // input::-webkit-input-placeholder {
  //   color: #000000;
  // }

  // input::-ms-input-placeholder {
  //   color: #000000;
  // }

  // .two {
  //   .width {
  //     width: 49%;
  //   }

  //   .el-input__inner {
  //     width: 100%;
  //   }

  //   display: flex;
  //   justify-content: space-between;
  // }

  // .three {
  //   display: flex;
  //   justify-content: space-between;

  //   .width_30 {
  //     width: 31%;

  //     .el-input__suffix {
  //       border-left: 1px rgba(179, 179, 179, 0.5) solid;
  //       height: 95%;
  //     }
  //   }
  // }

  // .place {
  //   width: 100%;
  //   height: 40px;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   padding: 0;
  //   margin-top: 50px;
  // }

  // .btn {
  //   cursor: pointer;
  //   // display: block;
  //   background-color: #ff6f37;
  //   background-clip: border-box;
  //   box-sizing: border-box;
  //   border: 1px transparent solid;
  //   border-radius: 5px;
  //   color: white;
  //   font-weight: 500;
  //   padding: 15px;
  //   text-align: center;
  //   position: relative;
  //   transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  //   float: right;
  // }

  // .btnCancel {
  //   cursor: pointer;
  //   display: inline-block;
  //   background-color: transparent;
  //   background-clip: border-box;
  //   box-sizing: border-box;
  //   border: 1px transparent solid black;
  //   border-radius: 5px;
  //   color: black;
  //   font-weight: 500;
  //   padding: 15px;
  //   text-align: center;
  //   position: relative;
  //   font-size: 14px;
  //   transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  // }
  // }

  .header_container {
    border-bottom: 1px solid silver;
    padding-bottom: 12px;
  }

  // .address_body_container {
  //   margin-top: 20px;
  //   display: flex;
  //   flex-direction: column;

  //   // border:
  //   .title {
  //     display: flex;
  //     justify-content: center;
  //     align-items: center;
  //     padding: 10px 0;
  //     color: #f5a623;
  //     background: #fdedd3;
  //     border: 1px solid #f5a623;
  //     cursor: pointer;

  //     span {
  //       font-weight: 700;
  //     }

  //     i {
  //       margin-right: 10px;
  //     }
  //   }
  // }

  .modal {
    margin-top: 100px;
  }

  // .dialog-footer {
  //   display: block;
  //   // flex-direction: row;
  //   // height:30px;
  //   // .btn_submit {
  //   //   float: right;
  //   // }
  // }

  // button {
  //   outline: none;
  // }

  // .time_tip {
  //   color: #f5a623;
  //   font-size: 12px;
  //   // margin-left: 10px;
  // }

  // .address-container {
  //   display: flex;
  //   flex-direction: column;
  //   background-color: #fce4bd;
  //   padding: 1em;
  //   border-radius: 0.2em;
  //   border: 1px solid #f5a623;
  //   border-top: none;

  //   .next-line {
  //     white-space: initial;
  //     display: inline-flex;
  //   }
  // }

  // ul {
  //   li {
  //     display: block;
  //     line-height: 30px;

  //     .deleteBtn {
  //       float: right;
  //     }

  //     .editBtn {
  //       float: right;
  //     }

  //     i {
  //       font-size: 20px;
  //       padding: 5px;
  //       cursor: pointer;
  //     }

  //     i:hover {
  //       color: #f5a623;
  //       // background: #f5a623;
  //       // background-color: red;
  //     }

  //   }
  // }

  // .greybackground {
  //   background-color: grey !important;
  // }
}
</style>



// WEBPACK FOOTER //
// src/view/Profile/information.vue